import React, { useEffect, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- External Usersnap SDK API
type UsersnapAPI = any;
declare global {
  /* eslint-disable @typescript-eslint/consistent-type-definitions -- global module augmentation requires interface */
  interface Window {
    onUsersnapCXLoad: (newApi: UsersnapAPI) => void;
  }
  /* eslint-enable @typescript-eslint/consistent-type-definitions */
}

const USERSNAP_API_KEY = '637ad411-8de6-4740-9d13-30ae69037c70';

const UsersnapContext = React.createContext(null);

export const UsersnapProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [usersnapApi, setUsersnapApi] = useState<UsersnapAPI | null>(null);

  useEffect(() => {
    if (usersnapApi || !USERSNAP_API_KEY) {
      return;
    }

    window.onUsersnapCXLoad = (newApi) => {
      newApi.init({});
      setUsersnapApi(newApi);
    };

    const script = document.createElement('script');

    script.defer = true;
    script.src = `https://widget.usersnap.com/global/load/${USERSNAP_API_KEY}?onload=onUsersnapCXLoad`;
    document.head.appendChild(script);

    return () => {
      if (usersnapApi) {
        usersnapApi.destroy();
      }

      script.remove();
    };
  }, [usersnapApi]);

  return (
    <UsersnapContext.Provider value={usersnapApi}>
      {children}
    </UsersnapContext.Provider>
  );
};
